import L from "leaflet";
// import "leaflet-extra-markers";
// import "font-awesome/css/font-awesome.css";
// import "leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css";
// import { config } from '@fortawesome/fontawesome-svg-core'
// import '@fortawesome/fontawesome-free/css/all.min.css';
import { uptimeToString } from '../../utils/converters'
import '../../styles/Icon.css'

export const colorMap = {
    'transformer': {
        fill: "#F57795",
        stroke: "#C76179",
        type: {
            default: {
                fill: "#F57795",
                stroke: "#C76179",
            },
            accounting: {
                fill: "#ff0000",
                stroke: "#AB0000",
            }
        },
        layers: {
            'construction': '#ff2b2b',
            'reconstruction': '#2196F3',
            'replacement': '#18c218'
        }
    },
    'pillar04': {
        fill: '#0302D9',
        type: {
            not_completed: { fill: '#ff2b2b' },
            completed: { fill: '#18c218' },
            half_completed: { fill: '#ffc000' },
            ready: { fill: '#2196F3' },
            rejected: { fill: '#9C27B0' }
        }
    },
    'fider04': {
        type: {
            default: ''
        }
    }
}

export const styles = {
    'transformer': {

        label_main: 'ТП 6(10)/0,4кВ',

        type: {
            //Стиль по умолчанию
            default: {
                style: {
                    fill: "#F57795",
                    stroke: "#C76179"
                },
                label: 'ТП',
            },
            //Стиль для ТП с предписанием
            accounting: {
                style: {
                    fill: "#ff0000",
                    stroke: "#AB0000",
                },
                label: 'ТП с предписанием'
            }
        },
        aux: {
            construction: {
                style: {
                    fill: '#ff2b2b',
                },
                label: 'Разработка'
            },
            reconstruction: {
                style: {
                    fill: '#2196F3',
                },
                label: 'Реконструкция'
            },
            replacement: {
                style: {
                    fill: '#18c218',
                },
                label: 'Замена'
            }
        }


    },
    'pillar04': {
        type: {
            default: { style: { fill: '#0302D9' }, label: 'Опора 0,4кВ' },
            not_completed: { style: { fill: '#ff2b2b' }, label: 'Опора 0,4кВ (Не устранено)' },
            completed: { style: { fill: '#18c218' }, label: 'Опора 0,4кВ (Устранено)' },
            half_completed: { style: { fill: '#ffc000' }, label: 'Опора 0,4кВ (Частично устранено)' },
            ready: { style: { fill: '#2196F3' }, label: 'Опора 0,4кВ (Готово к проверке)' },
            rejected: { style: { fill: '#9C27B0' }, label: 'Опора 0,4кВ (Отклонено)' }
        }


    }
}

export const translate = {
    not_completed: 'Не устранено',
    completed: 'Устранено',
    half_completed: 'Частично'
}

export function getLogo() {
    // let icon = { 'classname': 'fa fa-solid fa-code', 'color': 'green' }

    // return <span style={{ color: icon.color, opacity: '1', scale: '1.4 1.4', padding: '5px' }} className={icon.classname}></span>

    // return <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
    //     <path d="M384 476.1L192 421.2l0-385.3L384 90.8l0 385.3zm32-1.2l0-386.5L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2l0 386.5L32.9 474.5C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3z"
    //     fill='green'/>
    // </svg>
    return <img style={{ width: '40px' }} src="https://cloud.novaintegra.ru/apps/files_sharing/publicpreview/mapicons?file=/Logo%20Maps%20Komoks.png&fileId=7465&x=1920&y=1200&a=true&etag=3826857e9971bcea6e258d27028db9b1"></img>
    // return <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
    //     <path d="M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    //         fill='green'
    //     /></svg>

}





export function getSVGIcon(type, text = null, tags = null) {
    // console.log(type)
    var svgIcon = ''
    var popupAnchor = [0, 0]
    var tooltipAnchor = [0, 0]

    const colorMap = {
        'powerPlant': '#1E77B3',
        'feedingSubstation': '#40A438',
        'feedingSubstation_emergency': '#ff0000',
        'feedingSubstation_planned': '#574F6E',
        'transformer': '#e8718d',
        'transformer_accounting': '#ff0000',
        'res': "#000000",
        'pillar04': '#0302D9',
        'pillar04_accounting_half_completed': '#ffc000',
        'pillar04_accounting_completed': '#00dd00',
        'pillar04_accounting_not_completed': '#ff0000',
        'pillar04_accounting_ready': '#2196F3',
        'pillar04_accounting_rejected': '#9C27B0',
    }

    const statusColors = {
        'construction': '#ff2b2b',
        'reconstruction': '#2196F3',
        'replacement': '#18c218'
    }

    switch (type) {
        case 'powerPlant':
            svgIcon = `
            <div style='position:absolute; bottom: 0; display:flex; margin-left: 2px'>
            <svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24">
                <path d="M21.6,9.2l-9-6.5c-0.4-0.3-0.8-0.3-1.2,0l-9,6.5C2.1,9.4,1.9,9.9,2,10.3l3.4,10.6c0.1,0.4,0.5,0.7,1,0.7h11.1c0.4,0,0.8-0.3,1-0.7L22,10.3C22.1,9.9,21.9,9.4,21.6,9.2z"
                fill="#8CB9D7" stroke="#1E77B3" stroke-width="2px" opacity="0.9"/>
                />
                </svg>
            </div>`
            tooltipAnchor = [0, -5]
            popupAnchor = [0, -4]
            break;
        case 'feedingSubstation':
            svgIcon = `
             <div style='position:absolute; bottom: 0; display:flex; margin-left: 2px'>
             <svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24">
                <path d="M21.9,19.3l-9-15.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.3-1.1-0.2-1.4,0.3l-9,15.6C2,19.4,2,19.6,2,19.8c0,0.6,0.4,1,1,1h18c0.2,0,0.3,0,0.5-0.1C22,20.4,22.1,19.8,21.9,19.3z"
                    fill="#96CD93" stroke="#40A438" stroke-width="2px" opacity="0.9"/>
                </svg>
            </div>`
            tooltipAnchor = [0, -5]
            popupAnchor = [0, -4]
            break;
        case 'feedingSubstation_emergency':
            svgIcon = ` <div style='position:absolute; bottom: 0; display:flex; margin-left: 2px'>
            <svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24">
                    <path d="M21.9,19.3l-9-15.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.3-1.1-0.2-1.4,0.3l-9,15.6C2,19.4,2,19.6,2,19.8c0,0.6,0.4,1,1,1h18c0.2,0,0.3,0,0.5-0.1C22,20.4,22.1,19.8,21.9,19.3z"
                        fill="#ff0000" stroke="#ff0000" stroke-width="2px" opacity="0.9" fill-opacity="0.501961"/>
                    </svg>
                    </div>
                    <div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: -8px'>
                <svg width="36" height="36" viewBox="0 0 90 90">
                        <circle id="ring" r="45" cx="45" cy="45" fill="#574F6E" />
                    </svg>
                    </div>`
            tooltipAnchor = [0, -5]
            popupAnchor = [0, -4]
            break;
        case 'feedingSubstation_planned':
            svgIcon = `<div style='position:absolute; bottom: 0; display:flex; margin-left: 2px'>
            <svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24">
                        <path d="M21.9,19.3l-9-15.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.3-1.1-0.2-1.4,0.3l-9,15.6C2,19.4,2,19.6,2,19.8c0,0.6,0.4,1,1,1h18c0.2,0,0.3,0,0.5-0.1C22,20.4,22.1,19.8,21.9,19.3z"
                            fill="#8276A3" stroke="#574F6E" stroke-width="2px" opacity="0.9" fill-opacity="0.501961"/>
                        </svg>
                        </div>
                        <div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: -8px'>
                <svg width="36" height="36" viewBox="0 0 90 90">
                        <circle id="ring" r="45" cx="45" cy="45" fill="#574F6E" />
                    </svg>
                    </div>`
            tooltipAnchor = [0, -5]
            popupAnchor = [0, -4]
            break;
        case 'transformer':
            svgIcon = `
            <div style='position:absolute; bottom: 0; display:flex; margin-bottom: 12px; margin-left: 0'>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 3.3994775 7.3981276" version="1.1" id="svg1">
                <defs id="defs1"/>
                <g id="layer1" transform="translate(-103.45208,-144.7271)">
                    <g id="g6576" transform="matrix(0.08466653,0,0,0.08466653,-11.079747,62.222025)">
                    <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#C76179" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="#F57795" stroke-linecap="square" id="g6553" style="fill-rule:evenodd">
                        <path vector-effect="none" d="m 1009.25,378.107 c 0,9.785 -7.94,17.716 -17.72,17.716 -9.785,0 -17.717,-7.931 -17.717,-17.716 0,-9.785 7.932,-17.717 17.717,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6552"/>
                    </g>
                    <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#C76179" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="#F57795" stroke-linecap="square" id="g6554" style="fill-rule:evenodd">
                        <path vector-effect="none" d="m 1009.25,354.485 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.785,0 -17.717,-7.932 -17.717,-17.716 0,-9.785 7.932,-17.717 17.717,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6553"/>
                    </g>
                    <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#C76179" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill="none" stroke-linecap="square" id="g6555" style="fill-rule:evenodd">
                        <path vector-effect="none" d="m 991.53,313.146 v 23.622" fill-rule="evenodd" id="path6554"/>
                    </g>
                    </g>
                </g>
                </svg>
            </div>
            ${tags.layer && statusColors[tags.layer] ? `
                <div style='position:absolute; bottom: 0; display:flex; margin-left: -8px; margin-bottom: 4px'>
                    <svg width="40" height="40" viewBox="0 0 90 90">
                        <circle r="40" cx="45" cy="45" fill=none stroke="${statusColors[tags.layer]}" stroke-width="8" />
                    </svg>
                </div>
            ` : ''}
            
            `
            tooltipAnchor = [0, -24]
            popupAnchor = [0, -20]
            break;
        case 'transformer_accounting':
            svgIcon = `
            <div style='position:absolute; bottom: 0; display:flex; margin-bottom: 12px; margin-left: 0'>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 3.3997359 7.3981357" version="1.1" id="svg1">
                <defs id="defs1"/>
                <g id="layer1" transform="translate(-76.835657,-126.54452)">
                    <g stroke-opacity="1" transform="matrix(0.08464545,0,0,0.08464545,-19.793708,95.795296)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#AB0000" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="#ff0000" stroke-linecap="square" id="g6853" style="fill-rule:evenodd">
                    <path vector-effect="none" d="m 1179.38,430.594 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.78,0 -17.72,-7.932 -17.72,-17.716 0,-9.785 7.94,-17.717 17.72,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6852"/>
                    </g>
                    <g stroke-opacity="1" transform="matrix(0.08464545,0,0,0.08464545,-19.793708,95.795296)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#AB0000" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="#ff0000" stroke-linecap="square" id="g6854" style="fill-rule:evenodd">
                    <path vector-effect="none" d="m 1179.38,406.972 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.78,0 -17.72,-7.932 -17.72,-17.716 0,-9.785 7.94,-17.717 17.72,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6853"/>
                    </g>
                    <g stroke-opacity="1" transform="matrix(0.08464545,0,0,0.08464545,-19.793708,95.795296)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#AB0000" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill="none" stroke-linecap="square" id="g6855" style="fill-rule:evenodd">
                    <path vector-effect="none" d="m 1161.66,365.633 v 23.622" fill-rule="evenodd" id="path6854"/>
                    </g>
                </g>
                </svg>
                </div>
                  <div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: 6px'>
                <svg width="36" height="36" viewBox="0 0 90 90">
                    <circle id="ring" r="45" cx="45" cy="45" fill="#ff0000" />
                </svg>
                </div>
                ${tags.layer && statusColors[tags.layer] ? `
                    <div style='position:absolute; bottom: 0; display:flex; margin-left: -8px; margin-bottom: 4px'>
                        <svg width="40" height="40" viewBox="0 0 90 90">
                            <circle r="40" cx="45" cy="45" fill=none stroke="${statusColors[tags.layer] || '#e8718d'}" stroke-width="8" />
                        </svg>
                    </div>
                ` : ''}
                `
            tooltipAnchor = [0, -24]
            popupAnchor = [0, -20]
            break;


        case 'pillar04':
        case 'pillar04_accounting_half_completed':
        case 'pillar04_accounting_completed':
        case 'pillar04_accounting_not_completed':
        case 'pillar04_accounting_ready':
        case 'pillar04_accounting_rejected':
        case 'pillar04_accounting_approved':
            if (tags.mountStage > 0) {
                svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: -6px'>
                                <svg width="36" height="36" viewBox="0 0 100 100">
                                    <defs>
                                    <radialGradient id="RadialGradient1">
                                        <stop offset="0%" stop-color="#00dd00" stop-opacity="0" />
                                        <stop offset="50%" stop-color="#00dd00" stop-opacity="0.7" />
                                        <stop offset="100%" stop-color="#00dd00" stop-opacity="0" />
                                    </radialGradient>
                                    <radialGradient id="RadialGradient2">
                                        <stop offset="0%" stop-color="#ffa000" stop-opacity="0" />
                                        <stop offset="50%" stop-color="#ffa000" stop-opacity="0.7" />
                                        <stop offset="100%" stop-color="#ffa000" stop-opacity="0" />
                                    </radialGradient>
                                    </defs>
                                    <circle r="50" cx="50" cy="50" fill="url(#RadialGradient${tags.mountStage === 2 ? 1 : 2})" />
                                </svg>
                            </div>
                            `
            }
            svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: 5px; margin-bottom: 5px'>
                            <svg  width="14px" height="14px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24">
                            
                                ${tags.supports_count === 1 ?
                    `<circle r="40" cx="50" cy="50"fill="${tags.material_type === '1' ? 'none' : `var(--${type})`}" stroke="var(--${type})" stroke-width="20" />` : ''
                }
                                ${tags.supports_count === 2 ?
                    `<rect x="10" y="10" width="80" height="80" rx="5" fill="${tags.material_type === '1' ? 'none' : `var(--${type})`}" stroke="var(--${type})" stroke-width="20" />` : ''
                }
                                ${tags.supports_count === 3 ?
                    `<polygon points="50,10 90,90 10,90" fill="${tags.material_type === '1' ? 'none' : `var(--${type})`}" stroke="var(--${type})" stroke-width="20" />` : ''
                }                            
                            </svg>
                        </div>
                       `
            if (type.includes('pillar04_accounting') && !type.includes('approved')) {
                svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: -3px; margin-bottom: -3px'>
                            <svg width="30" height="30" viewBox="0 0 100 100">
                                <circle id="ring" r="50" cx="50" cy="50" fill="var(--${type})" />
                            </svg>
                        </div>
                        `
            }

            if (tags.grounding) {
                svgIcon += ` <div style='position:absolute; bottom: 0; display:flex; margin-left: ${text && text.position && text.position.includes('bottomright') ? -8 : 12}px; margin-bottom: -10px'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="22" height="22" fill="none">
                                <!-- Более короткая вертикальная линия -->
                                <line x1="32" y1="22" x2="32" y2="36" stroke="black" stroke-width="4" stroke-linecap="round" />

                                <!-- Первая горизонтальная линия -->
                                <line x1="20" y1="36" x2="44" y2="36" stroke="black" stroke-width="4" stroke-linecap="round" />

                                <!-- Вторая горизонтальная линия -->
                                <line x1="24" y1="42" x2="40" y2="42" stroke="black" stroke-width="4" stroke-linecap="round" />

                                <!-- Третья горизонтальная линия -->
                                <line x1="28" y1="48" x2="36" y2="48" stroke="black" stroke-width="4" stroke-linecap="round" />
                            </svg>
                        </div>`
            }
        // <div style='position:absolute; bottom: 0; display:flex; margin-left: 0px; margin-bottom: 0px'>
        // <svg width="24" height="24" viewBox="0 0 90 90">
        //     <circle id="ring" r="45" cx="45" cy="45" fill="var(--${type})" />
        // </svg>
        // </div>
        // tooltipAnchor = [0, -1]
        // popupAnchor = [0, -2]
        // break;
    }
    if (text && text.text) {
        let offset = 12
        if (type.includes('pillar')) offset = 12
        if (type.includes('transf')) offset = 24
        // let fntsize = window.innerWidth < 768 ? 12 : 14
        // if (printing) {
        //     fntsize = Number(fntsize * (printing / 100))
        // }
        // // let fntsize = 14
        // if (type.includes('pillar04')) { fntsize = fntsize - 2 }
        let mleft = 12 + 8
        // let mbottom = `${text.twoLineText ? 0 : text.fontSize}`
        let mbottom = offset
        switch (text.position) {
            case 'topleft':
                mleft = `-${text.size.width - 4}`
                break;
            case 'bottomright':
                mbottom = `-${text.size.height - offset}`
                break;
            case 'bottomleft':
                mleft = `-${text.size.width - 4}`
                mbottom = `-${text.size.height - offset}`
                break;
        }



        if (text.size) {
            // console.log(text)
            svgIcon += `<div style='position:absolute; bottom: 0; display:flex;  margin-left: ${mleft}px; margin-bottom: ${mbottom}px; z-index: 500'>
                <div style='color: var(--${type});font-weight: normal; font-size: ${text.fontSize}px; font-family: Arial, sans-serif; width: ${text.size.width}px; height: ${text.size.height} ; line-height: 1;
                    text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                        1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff; text-align: ${text.position.includes('right') ? 'start' : 'end'}; '>
                        <span>${text.text}</span>
                </div>
            </div>`
            //     svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: ${mleft}px; margin-bottom: ${mbottom}px'>
            //     <svg width="${text.size.width}" height="${text.size.height}" viewBox="0 0 ${text.size.width} ${text.size.height}">

            //         <text x="0" y="${text.fontSize}" font-size="${text.fontSize}px" style="text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
            //             1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;">
            //             <tspan fill="${colorMap[type]}">${text.text}</tspan>
            //         </text>

            //     </svg>
            // </div>`


        } else {
            svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: 20px; margin-bottom: 10px'>
            <div style='color: ${colorMap[type]};font-weight: normal; font-size: ${text.fontSize || 14}px; font-family: Arial, sans-serif;
                text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                    1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;  white-space: nowrap; text-align: center   ;'>
                    ${text.text}
            </div>
        </div>`
        }



    }
    // const offs = type.includes('trans') ? -2 : -7
    const iconMarker = new L.DivIcon({
        html: svgIcon,
        className: `icon-${type}`, // чтобы убрать стандартные стили
        iconSize: [24, 24], // Размер иконки
        popupAnchor: popupAnchor,
        tooltipAnchor: tooltipAnchor,
        iconAnchor: [12, 12] // Координаты якоря (центр нижнего края)
    });



    return iconMarker;
}


export function getSVGIconV2(tags, text = null) {
    // console.log(type)
    var svgIcon = ''
    var popupAnchor = [0, 0]
    var tooltipAnchor = [0, 0]

    // const colorMap = {
    //     'powerPlant': '#1E77B3',
    //     'feedingSubstation': '#40A438',
    //     'feedingSubstation_emergency': '#ff0000',
    //     'feedingSubstation_planned': '#574F6E',
    //     'transformer': '#e8718d',
    //     'transformer_accounting': '#ff0000',
    //     'res': "#000000",
    //     'pillar04': '#0302D9',
    //     'pillar04_accounting_half_completed': '#ffc000',
    //     'pillar04_accounting_completed': '#00dd00',
    //     'pillar04_accounting_not_completed': '#ff0000',
    //     'pillar04_accounting_ready': '#2196F3',
    //     'pillar04_accounting_rejected': '#9C27B0',
    // }

    // const statusColors = {
    //     'construction': '#ff2b2b',
    //     'reconstruction': '#2196F3',
    //     'replacement': '#18c218'
    // }


    switch (tags.class) {




        case 'transformer':

            svgIcon = `
                <div style='position:absolute; bottom: 0; display:flex; margin-bottom: 12px; margin-left: 0'>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 3.3994775 7.3981276" version="1.1" id="svg1">
                    <defs id="defs1"/>
                    <g id="layer1" transform="translate(-103.45208,-144.7271)">
                        <g id="g6576" transform="matrix(0.08466653,0,0,0.08466653,-11.079747,62.222025)">
                        <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="${colorMap[tags.class].type[tags.type]?.stroke || colorMap[tags.class].stroke}" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="${colorMap[tags.class].type[tags.type]?.fill || colorMap[tags.class].fill}" stroke-linecap="square" id="g6553" style="fill-rule:evenodd">
                            <path vector-effect="none" d="m 1009.25,378.107 c 0,9.785 -7.94,17.716 -17.72,17.716 -9.785,0 -17.717,-7.931 -17.717,-17.716 0,-9.785 7.932,-17.717 17.717,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6552"/>
                        </g>
                        <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="${colorMap[tags.class].type[tags.type]?.stroke || colorMap[tags.class].stroke}" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="${colorMap[tags.class].type[tags.type]?.fill || colorMap[tags.class].fill}" stroke-linecap="square" id="g6554" style="fill-rule:evenodd">
                            <path vector-effect="none" d="m 1009.25,354.485 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.785,0 -17.717,-7.932 -17.717,-17.716 0,-9.785 7.932,-17.717 17.717,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6553"/>
                        </g>
                        <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="${colorMap[tags.class].type[tags.type]?.stroke || colorMap[tags.class].stroke}" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill="none" stroke-linecap="square" id="g6555" style="fill-rule:evenodd">
                            <path vector-effect="none" d="m 991.53,313.146 v 23.622" fill-rule="evenodd" id="path6554"/>
                        </g>
                        </g>
                    </g>
                    </svg>
                </div>
                ${tags.type === 'accounting' ?
                    `<div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: 6px'>
                        <svg width="36" height="36" viewBox="0 0 90 90">
                            <circle id="ring" r="45" cx="45" cy="45" fill="#ff0000" />
                        </svg>
                    </div>` : ''
                }
                ${tags.layer ? `
                    <div style='position:absolute; bottom: 0; display:flex; margin-left: -8px; margin-bottom: 4px'>
                        <svg width="40" height="40" viewBox="0 0 90 90">
                            <circle r="40" cx="45" cy="45" fill=none stroke="${colorMap[tags.class].layers[tags.layer]}" stroke-width="8" />
                        </svg>
                    </div>
                ` : ''}
            
            `
            tooltipAnchor = [0, -24]
            popupAnchor = [0, -20]
            break;

        case 'pillar04':
            svgIcon = `
                <div style='position:absolute; bottom: 0; display:flex; margin-left: 8px; margin-bottom: 8px'>
                    <svg fill="#000000" width="8px" height="8px" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24">
                        <circle r="45" cx="45" cy="45" fill="${colorMap[tags.class].type[tags.type]?.fill || colorMap[tags.class].fill}" />
                    </svg>
                </div>
                ${tags.type ? `<div style='position:absolute; bottom: 0; display:flex; margin-left: 0px; margin-bottom: 0px'>
                    <svg width="24" height="24" viewBox="0 0 90 90">
                        <circle id="ring" r="45" cx="45" cy="45" fill="${colorMap[tags.class].type[tags.type]?.fill || colorMap[tags.class].color}" />
                    </svg>
                </div>`: ''
                }
                `
            tooltipAnchor = [0, -1]
            popupAnchor = [0, -2]
            break;


    }
    if (text && text.text) {
        let offset = 12
        if (tags.class === 'pillar04') offset = 12
        if (tags.class === 'transformer') offset = 24
        // let fntsize = window.innerWidth < 768 ? 12 : 14
        // if (printing) {
        //     fntsize = Number(fntsize * (printing / 100))
        // }
        // // let fntsize = 14
        // if (type.includes('pillar04')) { fntsize = fntsize - 2 }
        let mleft = 12 + 8
        // let mbottom = `${text.twoLineText ? 0 : text.fontSize}`
        let mbottom = offset
        switch (text.position) {
            case 'topleft':
                mleft = `-${text.size.width - 4}`
                break;
            case 'bottomright':
                mbottom = `-${text.size.height - offset}`
                break;
            case 'bottomleft':
                mleft = `-${text.size.width - 4}`
                mbottom = `-${text.size.height - offset}`
                break;
        }



        if (text.size) {
            // console.log(text)
            svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: ${mleft}px; margin-bottom: ${mbottom}px; z-index: 500'>
                <div style='color: ${colorMap[tags.class].type[tags.type]?.fill || colorMap[tags.class].fill};font-weight: normal; font-size: ${text.fontSize}px; width: ${text.size.width}px; height: ${text.size.height} ; line-height: 1;
                    text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                        1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff; text-align: ${text.position.includes('right') ? 'start' : 'end'}; '>
                        <span>${text.text}</span>
                </div>
            </div>`
            //     svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: ${mleft}px; margin-bottom: ${mbottom}px'>
            //     <svg width="${text.size.width}" height="${text.size.height}" viewBox="0 0 ${text.size.width} ${text.size.height}">

            //         <text x="0" y="${text.fontSize}" font-size="${text.fontSize}px" style="text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
            //             1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;">
            //             <tspan fill="${colorMap[type]}">${text.text}</tspan>
            //         </text>

            //     </svg>
            // </div>`


        } else {
            svgIcon += `<div style='position:absolute; bottom: 0; display:flex; margin-left: 20px; margin-bottom: 10px'>
            <div style='color: ${colorMap[tags.class].type[tags.type]?.fill || colorMap[tags.class].fill};font-weight: normal; font-size: ${text.fontSize || 14}px; 
                text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
                    1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;  white-space: nowrap; text-align: center   ;'>
                    ${text.text}
            </div>
        </div>`
        }



    }
    // const offs = type.includes('trans') ? -2 : -7
    const iconMarker = new L.DivIcon({
        html: svgIcon,
        className: `icon-${tags.class}`, // чтобы убрать стандартные стили
        iconSize: [24, 24], // Размер иконки
        popupAnchor: popupAnchor,
        tooltipAnchor: tooltipAnchor,
        iconAnchor: [12, 12] // Координаты якоря (центр нижнего края)
    });



    return iconMarker;
}

export function getSVGText(text, type) {
    const colorMap = {
        'powerPlant': '#1E77B3',
        'feedingSubstation': '#40A438',
        'transformer': '#e8718d',
        'transformer_es': '#ff0000',
        'transformer_ps': '#574F6E',
        'res': "#000000"
    }
    const html = `
    <div style='width: 100%; text-align: center; justify-content: center; white-space: nowrap;text-align: center   '>
    <div style='color: ${colorMap[type]};font-weight: normal; font-size: ${window.innerWidth < 768 ? '12px' : '14px'}; 
        text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
               1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;  white-space: nowrap; text-align: center   ;'>${text}</div>
    </div>
        
    `
    const iconMarker = new L.DivIcon({
        html: html,

        className: 'icon-text', // чтобы убрать стандартные стили
        // iconSize: [500, 20], // Размер иконки
        popupAnchor: [5, -20],
        iconAnchor: [-15, 30] // Координаты якоря (центр нижнего края)
    });

    return iconMarker;
}

export function getSVGProviderIcon(provider) {
    if (provider === 'Yandex') {
        return (
            <svg width="20px" height="20px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" style={{ margin: '0 2px 0 0' }}><title>file_type_yandex</title>
                <path d="M21.88,2h-4c-4,0-8.07,3-8.07,9.62a8.33,8.33,0,0,0,4.14,7.66L9,28.13A1.25,1.25,0,0,0,9,29.4a1.21,1.21,0,0,0,1,.6h2.49a1.24,1.24,0,0,0,1.2-.75l4.59-9h.34v8.62A1.14,1.14,0,0,0,19.82,30H22a1.12,1.12,0,0,0,1.16-1.06V3.22A1.19,1.19,0,0,0,22,2ZM18.7,16.28h-.59c-2.3,0-3.66-1.87-3.66-5,0-3.9,1.73-5.29,3.34-5.29h.94Z"
                    fill="#ff0000" />
            </svg>
        )
    } else {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="20px" height="20px" viewBox="0 0 32 32" style={{ margin: '0 2px 0 0' }}>
                <path d="M3.563 31.959c-0.469-0.12-0.713-0.313-1.964-1.557-1.484-1.484-1.577-1.631-1.572-2.401 0-0.86-0.267-0.552 4.489-5.317 4.796-4.808 4.552-4.6 5.416-4.6 0.407 0 0.505 0.021 0.828 0.188l0.371 0.188 2.323-2.323-0.292-0.459c-0.563-0.885-1.099-2.172-1.339-3.24-0.677-3.016 0.052-6.172 1.975-8.588 3.317-4.156 9.276-5.084 13.676-2.115 2.417 1.625 3.991 4.129 4.439 7.083 0.093 0.625 0.093 2.104 0 2.767-0.297 2.228-1.333 4.296-2.939 5.869-0.744 0.771-1.624 1.407-2.593 1.869-1.276 0.641-2.364 0.943-3.839 1.068-2.099 0.177-4.427-0.407-6.208-1.547l-0.459-0.292-2.328 2.323 0.188 0.376c0.167 0.323 0.187 0.421 0.187 0.823 0.005 0.864 0.209 0.62-4.567 5.396-3.683 3.676-4.251 4.219-4.532 4.348-0.359 0.167-0.916 0.229-1.26 0.141zM23.312 18.599c2.672-0.495 4.953-2.235 6.141-4.677 1.853-3.869 0.604-8.411-2.975-10.812-0.848-0.573-2.036-1.057-3.156-1.281-0.771-0.156-2.411-0.14-3.219 0.032-1.172 0.244-2.287 0.728-3.265 1.421-0.593 0.416-1.573 1.396-1.984 1.979-2.292 3.209-2.084 7.573 0.505 10.543 1.337 1.541 3.187 2.552 5.203 2.848 0.677 0.104 2.057 0.079 2.755-0.047zM18.328 28.432c-0.979-0.271-1.953-0.563-2.927-0.864-0.032-0.037 1.609-5.865 1.677-5.932 0.031-0.037 5.656 1.536 5.885 1.645 0.083 0.036-0.005 0.385-0.704 2.801-0.281 0.996-0.563 1.991-0.844 2.985-0.036 0.115-0.093 0.208-0.129 0.208-0.036-0.005-1.369-0.385-2.959-0.844zM22.213 29.136c0-0.073 1.636-5.781 1.661-5.797 0.063-0.047 5.765-1.641 5.787-1.615 0.027 0.025-1.599 5.781-1.64 5.812-0.027 0.027-5.5 1.589-5.677 1.625-0.073 0.016-0.131 0-0.131-0.025zM12.74 26.584c1.124-1.136 2.129-2.168 2.229-2.303 0.228-0.292 0.541-0.975 0.629-1.355 0.037-0.156 0.073-0.468 0.079-0.692l0.016-0.412 0.239-0.068c0.141-0.036 0.261-0.057 0.271-0.047 0.032 0.037-1.609 5.761-1.661 5.813-0.025 0.020-0.901 0.285-1.953 0.583l-1.895 0.541 2.047-2.057zM23.792 22.505c-0.032-0.084-0.057-0.167-0.079-0.251l-0.063-0.208 0.209-0.036c1.785-0.303 3.703-1.141 5.213-2.281 0.213-0.167 0.333-0.229 0.353-0.183 0.068 0.219 0.36 1.265 0.355 1.281-0.047 0.041-5.975 1.708-5.989 1.683zM3.683 20.771c-0.068-0.052-1.573-5.151-1.688-5.719-0.021-0.115 0.193-0.057 2.901 0.713 2.823 0.808 2.921 0.839 2.959 0.989 0.041 0.131 0.015 0.172-0.167 0.297-0.109 0.079-1.027 0.964-2.032 1.969-0.604 0.619-1.224 1.224-1.849 1.823-0.020 0-0.077-0.032-0.124-0.073zM4.776 14.932c-1.583-0.453-2.885-0.828-2.891-0.833-0.021-0.016 1.683-5.911 1.713-5.948 0.032-0.025 5.896 1.615 5.959 1.672 0.011 0.011-0.36 1.355-0.823 2.984-0.771 2.693-0.86 2.964-0.964 2.959-0.068 0-1.411-0.38-3-0.833zM8.719 15.651c0.016-0.041 0.287-0.963 0.593-2.047l0.557-1.964 0.079 0.428c0.125 0.739 0.355 1.583 0.62 2.317 0.14 0.396 0.244 0.719 0.239 0.729-0.009 0.011-0.443 0.136-0.957 0.281-0.521 0.145-0.989 0.281-1.047 0.301-0.079 0.021-0.105 0.005-0.084-0.047zM6.541 8.151c-1.583-0.453-2.891-0.848-2.905-0.875-0.057-0.083-1.663-5.76-1.641-5.781 0.032-0.036 5.745 1.604 5.803 1.661 0.063 0.068 1.703 5.839 1.661 5.833l-2.912-0.839zM9.407 5.864l-0.693-2.405-0.104-0.376 2.255-0.645c1.245-0.349 2.297-0.656 2.349-0.677 0.041-0.020-0.115 0.188-0.349 0.448-1.233 1.36-2.129 2.995-2.609 4.765-0.077 0.245-0.135 0.496-0.176 0.745 0 0.396-0.157-0.031-0.672-1.849z"
                    fill="#C9FF20" stroke="#2CFF01"
                />
            </svg>
        )
    }
}

export function getSVGAddressIcon(type) {
    let html = ''
    switch (type) {
        case 'shop':
        case 'tourism':
        case 'building':
        case 'place':
        case 'amenity':
        case 'retail':
        case 'construction':
        case 'bay':
            return (<svg width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path d="M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
                    fill="orange"
                /></svg>)
        case 'road':
        case 'street':
            return (
                <svg width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                    <path d="M256 32l-74.8 0c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480L256 480l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 201.4 0c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32L320 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm64 192l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                        fill="#4852E8"
                    />
                </svg>
            )
        case 'city':
        case 'village':
        case 'municipality':
        case 'locality':
        case 'district':
            return (
                <svg width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                    <path d="M480 48c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48l0 48-64 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-64 0 0-72c0-13.3-10.7-24-24-24S64 10.7 64 24l0 72L48 96C21.5 96 0 117.5 0 144l0 96L0 464c0 26.5 21.5 48 48 48l256 0 32 0 96 0 160 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-112 0 0-144zm96 320l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM240 416l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM560 256c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM256 176l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM256 304c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM112 320l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zm304-48l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zm16 112l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16z"
                        fill="white"
                    />
                </svg>
            )
        default:
            return (<svg width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path d="M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
                    fill="orange"
                /></svg>)
    }

}

function calculatePercentage(array) {
    const colorMap = {
        'pillar04': '#0302D9',
        'pillar10': '#0302D9',
        'pillar04-10': '#0302D9',
        'pillar_default': '#0302D9',
        'default': '#0302D9',
        'accounting_not_completed': '#ff0000',
        'accounting_half_completed': '#ffc000',
        'accounting_rejected': '#9C27B0',
        'accounting_completed': '#00df00',
        'accounting_ready': '#2196F3',
        'accounting_approved': '#2196F3',
        'pillar_not_completed': '#ff0000',
        'pillar_half_completed': '#ffc000',
        'pillar_rejected': '#9C27B0',
        'pillar_completed': '#00df00',
        'pillar_ready': '#2196F3',
        'pillar_approved': '#2196F3',
        'pillar04_accounting': '#ff0000',
        'pillar04_completed': '#00df00',
        'pillar04_half_completed': '#ffc000',
        'pillar04_not_completed': '#ff0000',
        'pillar04_ready': '#2196F3',
        'pillar04_rejected': '#9C27B0',
        'construction': '#ff2b2b',
        'reconstruction': '#2196F3',
        'replacement': '#18c218',
        '2': 'red',
        '3': '#4994ec',
        '4': '#c49b33',
        '7': '#ea33f7'
    }
    const totalCount = array.length;
    const counts = array.reduce((acc, num) => {
        acc[num] = (acc[num] || 0) + 1;
        return acc;
    }, {});

    const percentages = [];
    for (const [key, value] of Object.entries(counts)) {
        // percentages.push({ angle: (value / totalCount) * 360, color: colorMap[key], type: key })
        percentages.push({ angle: (value / totalCount) * 360, color: `var(--${key})`, type: key })
        // percentages[key] = (value / totalCount) * 360;
    }

    return percentages;
}

export function createConicGradientSVGCircleFilled(sectors, radius = 50) {
    const center = radius
    // const radius = 50
    let currentAngle = 0;
    if (sectors.length === 1) {
        return `<svg viewBox="0 0 100 100" width="20px" height="20px">
                    <circle cx="50" cy="50" r="50" fill="${sectors[0].color}"/>
                </svg>`
    }
    let paths = ''
    // for (let index = 0; index < sectors.length; index++) {

    sectors.map(({ angle, color }) => {
        const startAngle = (currentAngle - 90) * Math.PI / 180;
        const endAngle = (currentAngle + angle - 90) * Math.PI / 180;
        const largeArc = angle > 180 ? 1 : 0;
        // Расчет координат точек
        const x1 = center + radius * Math.cos(startAngle);
        const y1 = center + radius * Math.sin(startAngle);
        const x2 = center + radius * Math.cos(endAngle);
        const y2 = center + radius * Math.sin(endAngle);
        paths = paths + `<path d="M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1  ${x2} ${y2} Z" fill="${color}"/>`
        currentAngle += angle;
    })

    return `<svg viewBox="0 0 100 100" width="20px" height="20px">
                ${paths}
            </svg>`
}

export function createConicGradientSVGCircleStroked(sectors, size = 50) {
    const center = 50
    const radius = 50
    const border = radius / 5
    let currentAngle = 0;
    if (sectors.length === 1) {
        return `<svg viewBox="0 0 100 100" width="40px" height="40px">
                    <circle cx="50" cy="50" r="45" fill="none" stroke="${sectors[0].color}" stroke-width="10"/>
                </svg>`
    }
    let paths = ''
    // for (let index = 0; index < sectors.length; index++) {

    sectors.map(({ angle, color }) => {
        const startAngle = (currentAngle - 90) * Math.PI / 180;
        const endAngle = (currentAngle + angle - 90) * Math.PI / 180;
        const largeArc = angle > 180 ? 1 : 0;
        // Расчет координат точек
        const x1 = center + radius * Math.cos(startAngle);
        const x1inner = center + (radius - border) * Math.cos(startAngle);
        const y1inner = center + (radius - border) * Math.sin(startAngle);
        const y1 = center + radius * Math.sin(startAngle);
        const x2 = center + radius * Math.cos(endAngle);
        const x2inner = center + (radius - border) * Math.cos(endAngle);
        const y2 = center + radius * Math.sin(endAngle);
        const y2inner = center + (radius - border) * Math.sin(endAngle);
        // paths = paths + `<path d="M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} Z" fill="${color}"/>`
        // paths = paths + `<path d="
        //     M ${x1} ${y1 + border} 
        //     L ${x1} ${y1} 
        //     A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} 
        //     L ${x2 - border} ${y2} 
        //     A ${radius - border} ${radius - border} 0 ${largeArc} 0 ${x1} ${y1 + border} 
        //     Z" fill="${color}"/>`
        paths = paths + `<path d="
            M ${x1inner} ${y1inner} 
            L ${x1} ${y1} 
            A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} 
            L ${x2inner} ${y2inner} 
            A ${radius - border} ${radius - border} 0 ${largeArc} 0 ${x1inner} ${y1inner} 
            Z" fill="${color}"/>`
        currentAngle += angle;
    })

    return `<svg viewBox="0 0 100 100" width="40px" height="40px">
                ${paths}
            </svg>`
}

function generateConicGradient(percentages) {
    // console.log(percentages)
    const colorMap = {
        'pillar04': '#0302D9',
        'pillar04_accounting_ready': '#2196F3',
        'pillar04_accounting_completed': '#00df00',
        'pillar04_accounting_not_completed': '#ff0000',
        'pillar04_accounting_half_completed': '#ffc000',
        'pillar04_accounting_rejected': '#9C27B0',
    }
    let gradientParts = [];
    let cumulativePercentage = 0;

    for (const [num, percent] of Object.entries(percentages)) {
        // gradientParts.push(`${colorMap[num]} ${cumulativePercentage}% ${cumulativePercentage + percent}%`);
        gradientParts.push(`var(--${num}) ${cumulativePercentage}% ${cumulativePercentage + percent}%`);
        cumulativePercentage += percent;
    }

    return `conic-gradient(${gradientParts.join(', ')})`;
}


export function getIconMarkerCluster(count, type, types, viewProjectStatus = false) {
    // console.log(type, types)
    var svgIcon = ''

    const colorMap = {
        0: '#008C3A',
        1: '#21A2DA',
        2: '#F4B62A',
        3: '#F28A18',
        4: '#D32D19',
        5: '#9C262A',
    }

    const textLength = {
        1: [300, 330],
        2: [300, 330],
        3: [280, 440],
        4: [220, 480],
        5: [200, 500]
    }

    let markerColor = colorMap[0];
    let percentages = null
    if (types) {
        percentages = calculatePercentage(types)
    }
    switch (type) {

        case 'transformer':
            svgIcon = `
            ${percentages && viewProjectStatus ? `
                    <div style='position:absolute; bottom: 0; display:flex; margin-left: -8px; margin-bottom: -8px'>
                        ${createConicGradientSVGCircleStroked(percentages)}
                    </div>
                ` : ''
                }
            <div style='position:absolute; bottom: 0; display:flex; margin-left: 0'>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 3.3994775 7.3981276" version="1.1" id="svg1">
                <defs id="defs1"/>
                <g id="layer1" transform="translate(-103.45208,-144.7271)" filter="url(#shadow)">
                    <g id="g6576" transform="matrix(0.08466653,0,0,0.08466653,-11.079747,62.222025)">
                    <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#C76179" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="#F57795" stroke-linecap="square" id="g6553" style="fill-rule:evenodd">
                        <path vector-effect="none" d="m 1009.25,378.107 c 0,9.785 -7.94,17.716 -17.72,17.716 -9.785,0 -17.717,-7.931 -17.717,-17.716 0,-9.785 7.932,-17.717 17.717,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6552"/>
                    </g>
                    <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#C76179" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="#F57795" stroke-linecap="square" id="g6554" style="fill-rule:evenodd">
                        <path vector-effect="none" d="m 1009.25,354.485 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.785,0 -17.717,-7.932 -17.717,-17.716 0,-9.785 7.932,-17.717 17.717,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6553"/>
                    </g>
                    <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#C76179" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill="none" stroke-linecap="square" id="g6555" style="fill-rule:evenodd">
                        <path vector-effect="none" d="m 991.53,313.146 v 23.622" fill-rule="evenodd" id="path6554"/>
                    </g>
                    </g>
                </g>
                </svg>
            </div>
            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -8px; margin-left: -7px'>
                <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
                    <circle cx="256" cy="256" r="236" fill="#F57795" stroke="#C76179" stroke-width="0" fill-opacity="0.8"/>
                </svg>
            </div>
            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -8px; margin-left: -7px'>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                    <text x="290" y="256" font-size="300" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${count > 100 ? 430 : 330}" alignment-baseline="middle" font-style="bold" >
                    ${count}
                    </text>
                </svg>
            </div>           
            `
            break;
        case 'transformer_accounting':
            svgIcon = `
            ${percentages && viewProjectStatus ? `
                    <div style='position:absolute; bottom: 0; display:flex; margin-left: -8px; margin-bottom: -8px'>
                        ${createConicGradientSVGCircleStroked(percentages)}
                    </div>
                ` : ''
                }
            <div style='position:absolute; bottom: 0; display:flex; margin-left: 0'>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 3.3997359 7.3981357" version="1.1" id="svg1">
                <defs id="defs1"/>
                <g id="layer1" transform="translate(-76.835657,-126.54452)">
                    <g stroke-opacity="1" transform="matrix(0.08464545,0,0,0.08464545,-19.793708,95.795296)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#CB0000" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="#ff0000" stroke-linecap="square" id="g6853" style="fill-rule:evenodd">
                    <path vector-effect="none" d="m 1179.38,430.594 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.78,0 -17.72,-7.932 -17.72,-17.716 0,-9.785 7.94,-17.717 17.72,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6852"/>
                    </g>
                    <g stroke-opacity="1" transform="matrix(0.08464545,0,0,0.08464545,-19.793708,95.795296)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#CB0000" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="#ff0000" stroke-linecap="square" id="g6854" style="fill-rule:evenodd">
                    <path vector-effect="none" d="m 1179.38,406.972 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.78,0 -17.72,-7.932 -17.72,-17.716 0,-9.785 7.94,-17.717 17.72,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6853"/>
                    </g>
                    <g stroke-opacity="1" transform="matrix(0.08464545,0,0,0.08464545,-19.793708,95.795296)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="#CB0000" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill="none" stroke-linecap="square" id="g6855" style="fill-rule:evenodd">
                    <path vector-effect="none" d="m 1161.66,365.633 v 23.622" fill-rule="evenodd" id="path6854"/>
                    </g>
                </g>
                </svg>
            </div>
            <div style='position:absolute; bottom: 0; display:flex; margin-left: -6px; margin-bottom: -6px'>
                <svg width="36" height="36" viewBox="0 0 90 90">
                    <circle id="ring" r="45" cx="45" cy="45" fill="#ff0000" />
                </svg>
            </div>
            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -8px; margin-left: -7px'>
                <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
                    <circle cx="256" cy="256" r="236" fill="#ff0000" stroke="#AB0000" stroke-width="0" fill-opacity="0.8"/>
                </svg>
            </div>
            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -8px; margin-left: -7px'>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                    <text x="290" y="256" font-size="${textLength[count.toString().length][0]}" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${textLength[count.toString().length][1]}" alignment-baseline="middle" font-style="bold" >
                    ${count}
                    </text>
                </svg>
            </div>
            
                `
            break;

        case 'pillar04':
        case 'pillar_default':
        case 'pillar_accounting':
        case 'pillar_accounting_ready':
        case 'pillar_accounting_completed':
        case 'pillar_accounting_not_completed':
        case 'pillar_accounting_half_completed':
        case 'pillar_accounting_rejected':
        case 'pillar_accounting_approved':
        case 'pillar04_accounting':
        case 'pillar04_accounting_ready':
        case 'pillar04_accounting_completed':
        case 'pillar04_accounting_not_completed':
        case 'pillar04_accounting_half_completed':
        case 'pillar04_accounting_rejected':
        case 'pillar04_accounting_approved':
            // console.log(percentages)
            // const percentages = calculatePercentage(types)
            // const gradient = generateConicGradient(percentages);
            // svgIcon = `<div style='background:${gradient};' class='marker-cluster-div'></div>

            svgIcon = ` <div style='position:absolute; bottom: 0; display:flex; margin-left: 4px; margin-bottom: 4px'>
                                ${createConicGradientSVGCircleFilled(percentages)}
                                </div>

                        <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -2px; margin-left: -5px'>
                            <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
                                <circle cx="256" cy="256" r="236" fill="#5A5985" stroke="#5A5985" stroke-width="0" fill-opacity="0.7"/>
                            </svg>
                        </div>
                        <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -2px; margin-left: -6px'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                                <text x="290" y="256" font-size="${textLength[count.toString().length][0]}" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${textLength[count.toString().length][1]}" alignment-baseline="middle" font-style="bold" >
                                ${count}
                                </text>
                            </svg>
                        </div>   
            `
            // svgIcon = ` <div style='position:absolute; bottom: 0; display:flex; margin-left: 4px; margin-bottom: 4px'>
            //         <svg fill="#000000" width="16px" height="16px" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24">
            //                 <circle r="45" cx="45" cy="45" fill="#ff0000" />
            //                 </svg>
            //                 </div>
            //                 <div style='position:absolute; bottom: 0; display:flex; margin-left: -3px; margin-bottom: -3px'>
            //                 <svg width="30" height="30" viewBox="0 0 90 90">
            //                     <circle id="ring" r="45" cx="45" cy="45" fill="#ff0000" />
            //                 </svg>
            //                 </div>
            //      <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -6px; margin-left: -5px'>
            //     <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
            //         <circle cx="256" cy="256" r="236" fill="#8276A3" stroke="#574F6E" stroke-width="0" fill-opacity="0.8"/>
            //     </svg>
            // </div>
            // <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -6px; margin-left: -5px'>
            //     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
            //         <text x="290" y="256" font-size="${textLength[count.toString().length][0]}" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${textLength[count.toString().length][1]}" alignment-baseline="middle" font-style="bold" >
            //         ${count}
            //         </text>
            //     </svg>
            // </div>   
            //             `
            break;
        case 'pillarRlnd':
            svgIcon = `
                <div style='position:absolute; top: 0; display:flex; margin-left: 0px; margin-bottom: 0px'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="24" height="24">
                        <!-- Красный круг -->
                        <circle cx="32" cy="32" r="26" fill="red"/>

                        <!-- Горизонтальные контакты -->
                        <line x1="10" y1="36" x2="22" y2="36" stroke="white" stroke-width="5" stroke-linecap="round"/>
                        <line x1="42" y1="36" x2="54" y2="36" stroke="white" stroke-width="5" stroke-linecap="round"/>

                        <!-- Нож (укорочен) -->
                        <line x1="22" y1="36" x2="40" y2="20" stroke="white" stroke-width="5" stroke-linecap="round"/>

                        <!-- Ось шарнира -->
                        <circle cx="22" cy="36" r="3" fill="white"/>
                    </svg>
                </div>
                <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -5px; margin-left: -5px'>
                    <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
                        <circle cx="256" cy="256" r="236" fill="#5A5985" stroke="#5A5985" stroke-width="0" fill-opacity="0.7"/>
                    </svg>
                </div>
                <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -5px; margin-left: -6px'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                        <text x="290" y="256" font-size="${textLength[count.toString().length][0]}" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${textLength[count.toString().length][1]}" alignment-baseline="middle" font-style="bold" >
                        ${count}
                        </text>
                    </svg>
                </div>`
            break;
        case 'pillarRunn':
            svgIcon = `
                    <div style='position:absolute; top: 0; display:flex; margin-left: 0px; margin-bottom: 0px'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="26" height="26">
                            <!-- Корпус щита -->
                            <rect x="16" y="12" width="32" height="40" rx="4" fill="none" stroke="red" stroke-width="5" stroke-linecap="round"/>

                            <!-- Широкая красная молния -->
                            <polyline points="32,20 26,32 38,32 30,44" 
                                        fill="none" 
                                        stroke="red" 
                                        stroke-width="5" 
                                        stroke-linecap="round" 
                                        stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                    <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -5px; margin-left: -5px'>
                        <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
                            <circle cx="256" cy="256" r="236" fill="#5A5985" stroke="#5A5985" stroke-width="0" fill-opacity="0.7"/>
                        </svg>
                    </div>
                    <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -5px; margin-left: -6px'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                            <text x="290" y="256" font-size="${textLength[count.toString().length][0]}" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${textLength[count.toString().length][1]}" alignment-baseline="middle" font-style="bold" >
                            ${count}
                            </text>
                        </svg>
                    </div>`
            break;
        case 'pillarZvz':
            svgIcon = `
                        <div style='position:absolute; bottom: 0; display:flex; margin-left: 0px; margin-bottom: 0px'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="26" height="26">
                            <!-- Уменьшенный оранжевый круг -->
                            <circle cx="32" cy="32" r="22.4" fill="orange" />

                            <!-- Смещённый вверх белый значок -->
                            <!-- Вертикальная линия -->
                            <line x1="32" y1="18" x2="32" y2="32" stroke="white" stroke-width="4" stroke-linecap="round" />

                            <!-- Первая горизонтальная линия -->
                            <line x1="20" y1="32" x2="44" y2="32" stroke="white" stroke-width="4" stroke-linecap="round" />

                            <!-- Вторая горизонтальная линия -->
                            <line x1="24" y1="38" x2="40" y2="38" stroke="white" stroke-width="4" stroke-linecap="round" />

                            <!-- Третья горизонтальная линия -->
                            <line x1="28" y1="44" x2="36" y2="44" stroke="white" stroke-width="4" stroke-linecap="round" />
                            </svg>
                        </div>
                        <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -4px; margin-left: -5px'>
                            <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
                                <circle cx="256" cy="256" r="236" fill="#5A5985" stroke="#5A5985" stroke-width="0" fill-opacity="0.7"/>
                            </svg>
                        </div>
                        <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -4px; margin-left: -6px'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                                <text x="290" y="256" font-size="${textLength[count.toString().length][0]}" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${textLength[count.toString().length][1]}" alignment-baseline="middle" font-style="bold" >
                                ${count}
                                </text>
                            </svg>
                        </div>`
            break;
        case 'pillarOpn':
            svgIcon = `
                            <div style='position:absolute; top: 0; display:flex; margin-left: 0px; margin-bottom: 0px'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="24" height="24">
                                <!-- Прямоугольный корпус с округлёнными углами -->
                                <rect x="20" y="16" width="24" height="32" rx="4" fill="none" stroke="orange" stroke-width="5" stroke-linecap="round"/>

                                <!-- Диагональная линия -->
                                <line x1="12" y1="44" x2="52" y2="20" stroke="orange" stroke-width="5" stroke-linecap="round"/>

                                <!-- Продолжение диагонали вверх -->
                                <line x1="52" y1="20" x2="52" y2="8" stroke="orange" stroke-width="5" stroke-linecap="round"/>

                                <!-- Продолжение диагонали вниз -->
                                <line x1="12" y1="44" x2="12" y2="56" stroke="orange" stroke-width="5" stroke-linecap="round"/>

                                <!-- Верхний вывод -->
                                <line x1="32" y1="4" x2="32" y2="16" stroke="orange" stroke-width="5" stroke-linecap="round"/>

                                <!-- Нижний вывод -->
                                <line x1="32" y1="48" x2="32" y2="60" stroke="orange" stroke-width="5" stroke-linecap="round"/>
                                </svg>
                                </div>
                            </div>
                            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -5px; margin-left: -5px'>
                                <svg  class="shadow1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
                                    <circle cx="256" cy="256" r="236" fill="#5A5985" stroke="#5A5985" stroke-width="0" fill-opacity="0.7"/>
                                </svg>
                            </div>
                            <div style='position:absolute; bottom: 0; left: 0; display: flex; margin-bottom: -5px; margin-left: -6px'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="24 -24 512 512">
                                    <text x="290" y="256" font-size="${textLength[count.toString().length][0]}" fill="white" lengthAdjust="spacing" text-anchor="middle" textLength="${textLength[count.toString().length][1]}" alignment-baseline="middle" font-style="bold" >
                                    ${count}
                                    </text>
                                </svg>
                            </div>`
            break;
    }

    const offs = type.includes('trans') ? -20 : -15
    const iconMarker = new L.DivIcon({
        html: svgIcon,
        className: `cluster-icon-${type}`, // чтобы убрать стандартные стили
        iconSize: [24, 24], // Размер иконки
        popupAnchor: [0, offs],
        tooltipAnchor: [-2, 0],
        iconAnchor: [12, 12] // Координаты якоря (центр нижнего края)
    });




    return iconMarker;

}


export function getLegendIcon(type, label) {
    // console.log(type)
    var icon = ''
    var legend = ''
    var popupAnchor = [0, 0]
    var tooltipAnchor = [0, 0]
    var style = null

    const colorMap = {
        'powerPlant': '#1E77B3',
        'feedingSubstation': '#40A438',
        'feedingSubstation_emergency': '#ff0000',
        'feedingSubstation_planned': '#574F6E',
        'transformer': '#e8718d',
        'transformer_accounting': '#ff0000',
        'res': "#000000",
        'pillar04': '#0302D9',
        'pillar04_accounting_half_completed': '#ffc000',
        'pillar04_accounting_completed': '#00dd00',
        'pillar04_accounting_not_completed': '#ff0000',
        'pillar04_accounting_ready': '#2196F3',
        'pillar04_accounting_rejected': '#9C27B0',
    }

    const tran = {
        'construction': '#ff2b2b',
        'reconstruction': '#2196F3',
        'replacement': '#18c218'
    }

    switch (type) {

        case 'transformer':
            style = styles[type].type[label]?.style || styles[type].type.default
            const styleAux = styles[type].aux[label]?.style || null
            icon = `
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 3.3994775 7.3981276" version="1.1" id="svg1">
                <defs id="defs1"/>
                <g id="layer1" transform="translate(-103.45208,-144.7271)">
                    <g id="g6576" transform="matrix(0.08466653,0,0,0.08466653,-11.079747,62.222025)">
                    <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="${style.stroke}" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="${style.fill}" stroke-linecap="square" id="g6553" style="fill-rule:evenodd">
                        <path vector-effect="none" d="m 1009.25,378.107 c 0,9.785 -7.94,17.716 -17.72,17.716 -9.785,0 -17.717,-7.931 -17.717,-17.716 0,-9.785 7.932,-17.717 17.717,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6552"/>
                    </g>
                    <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="${style.stroke}" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill-opacity="0.501961" fill="${style.fill}" stroke-linecap="square" id="g6554" style="fill-rule:evenodd">
                        <path vector-effect="none" d="m 1009.25,354.485 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.785,0 -17.717,-7.932 -17.717,-17.716 0,-9.785 7.932,-17.717 17.717,-17.717 9.78,0 17.72,7.932 17.72,17.717" fill-rule="evenodd" id="path6553"/>
                    </g>
                    <g stroke-opacity="1" transform="matrix(0.999751,0,0,0.999751,381.5314,663.76431)" font-size="54.1667px" stroke-width="4.72441" font-style="normal" stroke="${style.stroke}" stroke-linejoin="bevel" font-weight="400" font-family="'.AppleSystemUIFont'" fill="none" stroke-linecap="square" id="g6555" style="fill-rule:evenodd">
                        <path vector-effect="none" d="m 991.53,313.146 v 23.622" fill-rule="evenodd" id="path6554"/>
                    </g>
                    </g>
                </g>
                </svg>`
            legend = styleAux ? styles[type].aux[label].label : styles[type].type[label].label

            break;

        case 'pillar04':
            style = styles[type].type[label]?.style || styles[type].type.default
            icon = ` 
                    <svg fill="#000000" width="8px" height="8px" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24">
                            <circle r="45" cx="45" cy="45" fill="${style.fill}" />
                            </svg>
                            `
            legend = styles[type].type[label].label
            break;
        case 'fider04':
            const [lab, color, weight] = JSON.parse(label)
            icon = `<svg width="24px" height="24px" viewBox="0 10 200 200" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0" y="100" width="200" height="${weight * 10}" rx="20" fill="${color}" />
                        </svg>
            `
            legend = lab
            break;
    }







    return { legend, icon };
}